import React, { Component } from 'react';
import DashboardPage from './components/pages/Dashboard'
import {HashRouter, Route, Switch} from 'react-router-dom'
import PageNotFound from './components/pages/Pagenotfound';
import CveDetailPage from './components/pages/Cvedetail';


class App extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>

          <Route path="/" exact component={DashboardPage}/>
          <Route path="/cves/severity/:severityName" exact render={(props) => {
              let {severityName} = props.match.params;

              return (
                <DashboardPage title={severityName} severity={severityName}/>
              )
          }} />

          <Route path="/cve/:cveId" exact render={(props) => {
              let {cveId} = props.match.params;
              return (
                <CveDetailPage cveId={cveId} />
              )
          }} />

          <Route component={PageNotFound} />
        </Switch>
      </HashRouter>
    );
  }
}

export default App;